import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppShell from "@/components/AppShell";
import PricingPlans from "@/components/account/PricingPlans";

const Pricing = () => {
  const [params] = useSearchParams();
  const fromRaw = params.get("from") ?? "";
  // Only accept in-app absolute paths to avoid open-redirect.
  const isSafe = fromRaw.startsWith("/") && !fromRaw.startsWith("//");
  const backTo = isSafe ? fromRaw : "/dashboard?tab=account";
  const backLabel = isSafe && fromRaw.startsWith("/dashboard/design")
    ? "Back to design"
    : "Back to account";

  return (
    <AppShell>
      <main className="flex-1 w-full max-w-5xl mx-auto px-5 py-8">
        <Link
          to={backTo}
          className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground tracking-normal mb-4"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          {backLabel}
        </Link>
        <div className="mb-8">
          <h1
            className="text-2xl md:text-4xl font-display text-foreground"
            style={{ letterSpacing: "-0.72px" }}
          >
            Choose your plan
          </h1>
          <p className="text-muted-foreground text-sm mt-1">
            Upgrade for more designs, higher-resolution renders, and priority support.
          </p>
        </div>
        <PricingPlans />
      </main>
    </AppShell>
  );
};

export default Pricing;
